import { render, staticRenderFns } from "./teacher-attendance-view.vue?vue&type=template&id=23e11d56&"
import script from "./teacher-attendance-view.vue?vue&type=script&lang=js&"
export * from "./teacher-attendance-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports